module.exports = __webpack_public_path__ + "fonts/intelo-semibold.adbbae4.woff2";